<template>
	<page>
		<title-view>
			עדכונים
			<v-btn
				slot="actions"
				btn
				@click="openModal = true"
			>
				עדכון חדש
			</v-btn>
		</title-view>
		<row>
			<c-col>
				<updates-table @edit="onEdit" />
			</c-col>
		</row>
		<popup-dialog v-model="openModal">
			<span slot="header">יצירת/עריכת עדכון</span>
			<update-form
				v-if="openModal"
				@save="openModal=false"
			/>
		</popup-dialog>
	</page>
</template>

<script>
import UpdateForm from "src/view/updates/UpdateForm";
import UpdatesTable from "src/view/updates/UpdatesTable";
import UpdateModule from "src/store/modules/Update.module";

export default {
	name: "UpdatesView",
	components: { UpdatesTable, UpdateForm },
	data () {
		return {
			openModal: false,
		};
	},
	methods: {
		onEdit (Update) {
			this.$store.commit(UpdateModule.types.GET, Update);
			this.openModal = true;
		},
	},

};
</script>

<style scoped>

</style>
